import { render, staticRenderFns } from "./ThirdChangePassword.vue?vue&type=template&id=72b1b714&scoped=true"
import script from "./ThirdChangePassword.vue?vue&type=script&lang=js"
export * from "./ThirdChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ThirdChangePassword.vue?vue&type=style&index=0&id=72b1b714&prod&lang=css"
import style1 from "./ThirdChangePassword.vue?vue&type=style&index=1&id=72b1b714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1b714",
  null
  
)

export default component.exports